module.exports = __webpack_public_path__ + "img/footer-info-normal.1eada935.jpg";